const FADE_OUT_MS = 300;

const removeToastWrap = () => {
  document.querySelector('.jq-toast-wrap')?.remove();
};

const positionWrap = (wrap, position) => {
  if (position === 'top-center') {
    wrap.style.top = '20px';
    wrap.style.left = '50%';
    wrap.style.transform = 'translateX(-50%)';
  } else {
    wrap.classList.add(position);
  }
};

const fadeOutAndRemove = (wrap) => {
  wrap.style.transition = `opacity ${FADE_OUT_MS}ms`;
  wrap.style.opacity = '0';
  setTimeout(removeToastWrap, FADE_OUT_MS);
};

export const showToast = ({ heading, text, position = 'top-center', hideAfter = 3000, textAlign }) => {
  removeToastWrap();

  const wrap = document.createElement('div');
  wrap.className = 'jq-toast-wrap';
  positionWrap(wrap, position);

  const single = document.createElement('div');
  single.className = 'jq-toast-single';
  if (textAlign) single.style.textAlign = textAlign;

  const loader = document.createElement('span');
  loader.className = 'jq-toast-loader';
  loader.style.transition = `width ${hideAfter}ms linear`;
  single.appendChild(loader);

  const close = document.createElement('span');
  close.className = 'close-jq-toast-single';
  close.textContent = '×';
  close.addEventListener('click', removeToastWrap);
  single.appendChild(close);

  if (heading) {
    const headingElement = document.createElement('h2');
    headingElement.className = 'jq-toast-heading';
    headingElement.textContent = heading;
    single.appendChild(headingElement);
  }

  single.appendChild(document.createTextNode(text ?? ''));

  wrap.appendChild(single);
  document.body.appendChild(wrap);

  requestAnimationFrame(() => loader.classList.add('jq-toast-loaded'));
  setTimeout(() => fadeOutAndRemove(wrap), hideAfter);
};

export const toast = (message) => {
  showToast({ text: message, textAlign: 'center' });
};
